import { createRouter, createWebHistory } from 'vue-router';

//import pages
import SurveyIntroduction from './pages/home/SurveyIntroduction.vue';
import Register from './pages/register/CompanyForm.vue';
import Survey from './pages/survey/SurveyForm.vue';
import SurveyResult from './pages/survey/SurveyResult.vue';
import NotFound from './pages/NotFound.vue';
import SurveyBackoffice from './components/backoffice/SurveyBackoffice.vue';
import store from './store/index.js';

// create router
const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/home' },
    { path: '/home', component: SurveyIntroduction },
    { path: '/register', component: Register },
    { path: '/survey', component: Survey },
    { path: '/results', component: SurveyResult },
    { path: '/:notFound(.*)', component: NotFound }, // all undefined paths direct to the NotFound component
    { path: '/backoffice', component: SurveyBackoffice }, // path to download excel file
  ],
});

// Navigation guard
router.beforeEach((to, from, next) => {
  // // get the route we are departing from the state
  const previousRoute = store.state.previousRoute;

  // Convert the path to lowercase for case-sensitive comparison
  const lowercasePath = to.path.toLowerCase();

  // if user wants to go to survey path
  if (lowercasePath === '/survey') {
    // check if he has pressed the 'Avançar' button in the register path
    if (store.state.register.registerButtonPressed) {
      next();
    // if not, re route him to the route he was on or home
    } else {
      if (!previousRoute || previousRoute === '/survey') {
        next('/home');
      } else {
        next(previousRoute);
      }
    }

  // if the user wants to go to the results path
  } else if (lowercasePath === '/results') {
    // check if he has pressed the 'Submeter' button in the register path
    if (store.state.survey.surveyButtonPressed) {
      store.dispatch('survey/setButtonPressed', false);
      store.dispatch('register/setButtonPressed', false);
      next();
    } else {
      // if not, re route him to the route he was on or home
      if (!previousRoute || previousRoute === '/results' || (previousRoute === '/survey' && !store.state.register.registerButtonPressed)) {
        next('/home');
      } else {
        next(previousRoute);
      }
    }
  // if neither, proceed normally
  } else {
    next();
  }
});

export default router;